/* @generated from adl module ferovinum.sourcecontracts.dealroll */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.deal_roll` contract.
 */
export interface DealRollSource {
  id: ferovinum_app_db.DealRollId;
  fromDealLeg: ferovinum_app_db.DealLegId;
  toDealLeg: ferovinum_app_db.DealLegId;
  application: common_strings.StringNE;
  dealLegSaleId: ferovinum_app_db.DealLegSaleId;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeDealRollSource(
  input: {
    id: ferovinum_app_db.DealRollId,
    fromDealLeg: ferovinum_app_db.DealLegId,
    toDealLeg: ferovinum_app_db.DealLegId,
    application: common_strings.StringNE,
    dealLegSaleId: ferovinum_app_db.DealLegSaleId,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): DealRollSource {
  return {
    id: input.id,
    fromDealLeg: input.fromDealLeg,
    toDealLeg: input.toDealLeg,
    application: input.application,
    dealLegSaleId: input.dealLegSaleId,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const DealRollSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.dealroll","decl":{"annotations":[{"value":{"modelName":"source__app_db.deal_roll","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.deal_roll` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealRollId"}},"parameters":[]}},{"annotations":[],"serializedName":"fromDealLeg","default":{"kind":"nothing"},"name":"fromDealLeg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"toDealLeg","default":{"kind":"nothing"},"name":"toDealLeg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"application","default":{"kind":"nothing"},"name":"application","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"dealLegSaleId","default":{"kind":"nothing"},"name":"dealLegSaleId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLegSaleId"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"DealRollSource","version":{"kind":"nothing"}}};

export const snDealRollSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.dealroll", name:"DealRollSource"};

export function texprDealRollSource(): ADL.ATypeExpr<DealRollSource> {
  return {value : {typeRef : {kind: "reference", value : snDealRollSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.dealroll.DealRollSource" : DealRollSource_AST
};
